export default __webpack_public_path__ + "static/media/La Sagrada Familia.eeb8e0bc.svg";